import { FEATURE_NAME } from './constants';
import { createSlice } from '@reduxjs/toolkit';
import * as T from './types';
import * as actions from './actions';

const initialState: T.AttendeeStatsState = {
  attendeeStats: null,
  loading: false,
  error: null,
};

export const attendeeStatsSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actions.searchAttendeesStatsByEvent.fulfilled, (state, action) => {
      state.attendeeStats = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(actions.searchAttendeesStatsByEvent.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(actions.searchAttendeesStatsByEvent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});
